import { useState, useMemo } from 'react';
import './ProviderTypeahead.css';

function ProviderTypeahead({ value, onChange, onSelect, providers = [], placeholder, disabled, className }) {
  const [open, setOpen] = useState(false);

  const suggestions = useMemo(() => {
    const q = value.trim().toLowerCase();
    const list = q
      ? providers.filter(
          (p) =>
            p.name.toLowerCase().includes(q) ||
            (p.npi || '').includes(q)
        )
      : providers;
    return list.slice(0, 8);
  }, [providers, value]);

  return (
    <div className="pta-wrapper">
      <input
        type="text"
        className={className}
        value={value}
        onChange={onChange}
        onFocus={() => setOpen(true)}
        onBlur={() => setTimeout(() => setOpen(false), 150)}
        placeholder={placeholder}
        disabled={disabled}
        autoComplete="off"
      />
      {open && suggestions.length > 0 && (
        <div className="pta-dropdown">
          {suggestions.map((p) => (
            <div
              key={p.id}
              className="pta-option"
              onMouseDown={() => {
                onSelect(p);
                setOpen(false);
              }}
            >
              <span className="pta-option-name">{p.name}</span>
              {p.npi && <span className="pta-option-npi">NPI {p.npi}</span>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default ProviderTypeahead;
